import React, { useEffect, useState } from 'react';

import { Box, Button, Grid, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';

import {
  ComparePaymentPlanTypes,
  PaymentPlans,
  pharmacyName,
} from '@pharmaplan/common';

import { useAppDispatch } from '../../../../../hooks/useAppDispatch';
import { useAppSelector } from '../../../../../hooks/useAppSelector';
import { setDialog } from '../../../../../reducers/dialogReducer';
import ComparePaymentPlan from '../../../../ComparePaymentPlan';
import { Constants } from '../../../../../helpers/Constants';
import PaymentGateway from '../../../../PaymentGateway';
import strings from '../../../../../localization';

import PaymentPlanBlock from './PaymentPlanBlock';
import styles from './styles';

const GetPayment = () => {
  const dispatch = useAppDispatch();

  const { pathname } = useLocation();
  const navigate = useNavigate();

  const showPlan = pathname === Constants.paths.pharmacyBillingCompare;

  const name = useAppSelector(pharmacyName);
  const [paymentPlan, setPaymentPlan] = useState(PaymentPlans.basic);

  const showComparePlan = () => {
    dispatch(
      setDialog({
        Component: (
          <ComparePaymentPlan
            screenType={ComparePaymentPlanTypes.compare}
            setPaymentPlan={setPaymentPlan}
          />
        ),
        showCloseButton: false,
        maxWidth: 'md',
        heading: { title: '' },
      }),
    );
  };

  useEffect(() => {
    if (showPlan) {
      showComparePlan();
      navigate(Constants.paths.pharmacyBilling);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showPlan]);

  return (
    <>
      <Box sx={styles.headerContainer}>
        <Typography sx={styles.title}>
          {strings.formatString(strings.hiFormat, name ?? '')}
        </Typography>
        <Typography sx={styles.subtitle}>{strings.toGetStarted}</Typography>
      </Box>
      <Grid container columnSpacing={3}>
        <Grid item md={6} xs={12}>
          <PaymentPlanBlock
            paymentPlan={paymentPlan}
            setPaymentPlan={setPaymentPlan}
          />
          <Button
            onClick={showComparePlan}
            variant={Constants.variant.contained}
            sx={styles.comparePlanButton}
          >
            <Typography sx={styles.compareLabel}>
              {`${strings.comparePlan}s`}
            </Typography>
          </Button>
        </Grid>
        <Grid item md={6} xs={12}>
          <PaymentGateway paymentPlan={paymentPlan} />
        </Grid>
      </Grid>
    </>
  );
};

export default GetPayment;
